import { PaginationQueryDto, type PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { KktFiltersDto, KktFiltersInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-filters.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';

/** Kkts list with pagination API query parameters */
export interface KktQueryInterface extends PaginationQueryInterface, KktFiltersInterface {}

/** Kkts list with pagination API query parameters - DTO schema */
export const KktQueryDto = SerdeDtoClass.union<KktQueryInterface>(FinanceDtoKeysEnum.KKT_QUERY_DTO, [PaginationQueryDto, KktFiltersDto]);
